import ConfirmModal from 'views/components/ConfirmModal'

import useRemoveRoleHandler from '../../../effects/remove-role'
import { Role } from '../../../../../../../graphql'
import { heapEvent } from '@equipmentshare/heaper'

export type RemoveRoleModalProps = {
	onCancel: () => void,
	onSuccess: () => void,
	role: Role,
}

export default function RemoveRoleModal( { onCancel, onSuccess, role }: RemoveRoleModalProps ) {
	const removeRole = useRemoveRoleHandler()

	const handleSubmit = async() => {
		heapEvent( 'Inventory - Remove Role Modal - Click - Remove', {} )
		return await removeRole( role.id )
	}

	const handleCancel = () => {
		heapEvent( 'Inventory - Remove Role Modal - Click - Cancel', {} )
		onCancel()
	}

	return (
		<ConfirmModal
			message={`You are about to remove ${role.name}. Do you want to proceed?`}
			onConfirm={async() => await handleSubmit()}
			buttonColor="danger"
			buttonText="Remove"
			onCancel={handleCancel}
			onSuccess={onSuccess}
		/>
	)
}
